import { Dict } from '../submodules/utils/Types';

interface FileFormatInfo {
    extension: string;
    mimetype: string;
}

export type FileFormat = 'OBK' | 'OBX' | 'DWG' | '3DS' | 'FBX' | 'PDF' | 'HTML' | 'JPG' | 'PNG' | 'EXCEL' | 'PBOX' | 'ZIP';

export const FileFormats: {[P in FileFormat]: FileFormatInfo} = {
    OBK: {
        extension: 'obk',
        mimetype: 'application/obk'
    },
    OBX: {
        extension: 'obx',
        mimetype: 'application/obx'
    },
    DWG: {
        extension: 'dwg',
        mimetype: 'application/x-dwg'
    },
    '3DS': {
        extension: 'zip',
        mimetype: 'application/octet-stream'
    },
    FBX: {
        extension: 'fbx',
        mimetype: 'application/octet-stream'
    },
    PDF: {
        extension: 'pdf',
        mimetype: 'application/pdf'
    },
    HTML: {
        extension: 'html',
        mimetype: 'application/pdf'
    },
    JPG: {
        extension: 'jpg',
        mimetype: 'image/jpeg'
    },
    PNG: {
        extension: 'png',
        mimetype: 'image/png'
    },
    EXCEL: {
        extension: 'xlsx',
        mimetype: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    },
    PBOX: {
        extension: 'pbox',
        mimetype: 'application/octet-stream'
    },
    ZIP: {
        extension: 'zip',
        mimetype: 'application/zip'
    }
};

export const FileExtensionMapping: Dict<FileFormat> = ((): Dict<FileFormat> => {
    const mapping: Dict<FileFormat> = {
        jpeg: 'JPG' // allow both jpg and jpeg
    };

    for (const fileFormat of Object.keys(FileFormats)) {
        mapping[FileFormats[fileFormat].extension] = fileFormat as FileFormat;
    }

    return mapping;
})();


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/FileFormat.ts